import { PersonalCodeResult } from '@app/lib/personal-code/model/PersonalCodeResult';

function calcEstonianCheckDigit(code10: string): number {
    const digits = code10.split('').map(digit => Number(digit));

    const weight1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1];
    const weight2 = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3];

    const sum = (weights: number[]) => digits.reduce((acc, digit, index) => acc + digit * weights[index], 0);

    let mod = sum(weight1) % 11;
    if (mod !== 10) return mod;

    mod = sum(weight2) % 11;
    if (mod !== 10) return mod;

    return 0;
}

export function parseEstonianPersonalCode(personalCode: string): PersonalCodeResult {
    if (!/^\d{11}$/.test(personalCode)) return { isValid: false };

    const firstDigit = Number(personalCode[0]);

    if (![1, 2, 3, 4, 5, 6].includes(firstDigit)) return { isValid: false };

    const expectedCheck = calcEstonianCheckDigit(personalCode.substring(0, 10));
    const actualCheck = Number(personalCode[10]);

    if (expectedCheck !== actualCheck) return { isValid: false };

    const year = Number(personalCode.substring(1, 3));
    const month = Number(personalCode.substring(3, 5));
    const day = Number(personalCode.substring(5, 7));

    const gender: 'male' | 'female' = firstDigit % 2 === 1 ? 'male' : 'female';

    let century: number;
    switch (firstDigit) {
        case 1:
        case 2:
            century = 1800;
            break;
        case 3:
        case 4:
            century = 1900;
            break;
        case 5:
        case 6:
            century = 2000;
            break;
        default:
            return { isValid: false };
    }

    const fullYear = century + year;
    const birthDateObj = new Date(fullYear, month - 1, day);

    if (
        birthDateObj.getFullYear() !== fullYear ||
        birthDateObj.getMonth() !== month - 1 ||
        birthDateObj.getDate() !== day
    ) {
        return { isValid: false };
    }

    const birthDate = `${fullYear}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

    const today = new Date();
    let age = today.getFullYear() - fullYear;
    const monthDiff = today.getMonth() - (month - 1);

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < day)) age--;

    return {
        isValid: true,
        year: fullYear,
        age,
        gender,
        birthDate,
    };
}
